<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    };
  },
  methods: {
    $Can(permissionName) {
      // Signed-out visitors (the public Reports page allows them) have no user data or permissions.
      if (!this.userData) return false;
      if (this.userData.role === 'manager') {
        return true;
      } else {
        return (localStorage.getItem('userPerms') || '').includes(permissionName) ? true : false;
      }
    },
    $CanViewMenu(item) {
      if (!this.userData) return false;
      if (this.userData.role === 'manager') {
        return true;
      } else {
        return this.$Can(item.Permission);
      }
    },
  },
};
</script>
